import {
    PostContent,
    PostImage,
    PostPanel,
    PostSign,
    PostSubtitle,
    PostSignText,
    PostText,
    PostTitle,
    SquarePost,
    LinkButton,
} from "./Post.styles";
import React, { useState } from "react";
import { ColoredText } from "../../../parts/Navbar/Navbar.styles";
import { MAIN_COLOR } from "../../../components/globalThemes";
import Logo from "../../../components/logos/Logo/Logo";
import { formatDate } from "../../../helpers/helpersFunctions";
import { SHORT_NAME } from "../../../utils/info";

const Post = ({ id, images = [], title, text, date }) => {
    const [error, setError] = useState(false);

    return (
        <SquarePost key={id} to={"/news/" + id}>
            <PostImage
                image={images?.length}
                src={images?.length ? images[0] : "/logo.png"}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logo.png";
                    setError(true);
                }}
                error={error}
            />
            <PostPanel>
                <PostSign>
                    <PostSignText>
                        <ColoredText color={MAIN_COLOR}>
                            {SHORT_NAME}
                        </ColoredText>
                        {" News"}
                    </PostSignText>
                </PostSign>
                <PostContent>
                    <PostTitle>{title}</PostTitle>
                    <PostSubtitle>
                        {"Ostatnia aktualizacja: " + formatDate(date)}
                    </PostSubtitle>
                    <PostText>{decodeURI(text)}</PostText>
                    <Logo
                        width={200}
                        height={200}
                        style={{
                            position: "absolute",
                            right: 0,
                            bottom: -65,
                            opacity: 0.12,
                        }}
                    />
                </PostContent>
            </PostPanel>
            <LinkButton>{"PRZEJDŹ DO NEWSA"}</LinkButton>
        </SquarePost>
    );
};

export default Post;
